/** Complete the one-time exchange before importing the portal and its integrations. */
export async function startPortal(start: () => Promise<unknown>, browser: Window = window): Promise<void> {
  const parameters = new URLSearchParams(browser.location.hash.substring(1));
  let code = parameters.get('code');
  const hasCode = parameters.has('code');
  const polish = (browser.navigator.language || '').toLowerCase().startsWith('pl');
  const status = browser.document.getElementById('portal-startup-status');

  try {
    if (hasCode) {
      // Clear even malformed codes before requests, errors or third-party initialization.
      browser.history.replaceState(null, '', browser.location.pathname);
      const path = /^\/preview\/article\/([1-9][0-9]*)\/?$/.exec(browser.location.pathname);
      if (!path || parameters.getAll('code').length !== 1 || !code || !/^[A-Za-z0-9_-]{43}$/.test(code)) {
        throw new Error('Invalid preview link');
      }
      if (status) {
        status.textContent = polish ? 'Otwieranie podglądu…' : 'Opening preview…';
      }
      const base = '/angular-api/article/preview';
      const bootstrap = await browser.fetch(base + '/bootstrap', {
        credentials: 'same-origin', cache: 'no-store', redirect: 'error'
      });
      if (!bootstrap.ok) { throw new Error('Preview bootstrap failed'); }
      const csrf = browser.document.cookie.split(';').map(value => value.trim())
        .find(value => value.startsWith('XSRF-TOKEN='));
      if (!csrf) { throw new Error('CSRF unavailable'); }
      const body = JSON.stringify({code});
      code = null;
      const response = await browser.fetch(base + '/redeem', {
        method: 'POST', credentials: 'same-origin', cache: 'no-store', redirect: 'error',
        headers: {'Content-Type': 'application/json', 'X-XSRF-TOKEN': decodeURIComponent(csrf.substring('XSRF-TOKEN='.length))},
        body
      });
      if (!response.ok) { throw new Error('Preview unavailable'); }
      const grant = await response.json();
      if (!grant || typeof grant.previewId !== 'string' || !/^[A-Za-z0-9_-]{43}$/.test(grant.previewId)
          || !Number.isSafeInteger(grant.contentId) || grant.contentId <= 0 || String(grant.contentId) !== path[1]) {
        throw new Error('Invalid preview response');
      }
      browser.history.replaceState(null, '', '/preview/article/' + grant.contentId + '?previewId=' + grant.previewId);
    }
    await start();
  } catch {
    // Never expose the code or the server's error body in the DOM or console.
    if (status) {
      status.textContent = hasCode
        ? (polish ? 'Nie można otworzyć podglądu. Otwórz go ponownie przyciskiem „Podgląd” w panelu administracyjnym.'
          : 'Unable to open this preview. Open it again using Preview in the administration panel.')
        : (polish ? 'Nie można uruchomić portalu. Odśwież stronę, aby spróbować ponownie.'
          : 'Unable to start the portal. Reload the page to try again.');
    }
  } finally {
    code = null;
  }
}
